import { render, staticRenderFns } from "./Cockpit.vue?vue&type=template&id=2d8243d0&scoped=true"
import script from "./Cockpit.vue?vue&type=script&lang=js"
export * from "./Cockpit.vue?vue&type=script&lang=js"
import style0 from "./Cockpit.vue?vue&type=style&index=0&id=2d8243d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8243d0",
  null
  
)

export default component.exports